import styled from 'styled-components';
import { device } from 'components/styles/MediaQuery';

export const ScStaticModal = styled.div`
  position: relative;
  max-width: 640px;
  background: ${({ theme }) => theme.secondaryColor3};
  border-radius: 16px;
  margin: 72px auto;
  padding: 32px 24px;
  & > button {
    z-index: 1;
  }
  & > .title {
    font-weight: 700;
    font-size: 20px;
    line-height: 1.4;
    margin-bottom: 32px;
    padding-right: 80px;
  }
  h1 {
    font-size: 22px;
    line-height: 1.27;
    margin-bottom: 24px;
    color: ${({ theme }) => theme.whiteColor};
    font-weight: 700;
    letter-spacing: 0.01em;
    text-align: center;
    @media (${device.mobileS}) {
      font-size: 18px;
      line-height: 24px;
      margin: 16px 0;
      padding: 0 24px;
      text-align: left;
    }
  }
  @media (${device.mobileS}) {
    margin: 0 auto 21px;
    border-radius: 100px;
    padding: 0;
    border-radius: 16px 16px 0px 0px;
    background: none;
    width: 100%;
  }
`;

export const ScMobileBackground = styled.div`
  /* position: absolute;
  inset: 60px 0 0;
  z-index: -1;
  background-color: ${({ theme }) => theme.secondaryColor3};
  border-radius: 16px 16px 0px 0px; */
`;

export const ScStaticPage = styled.div`
  font-size: 14px;
  line-height: 1.43;
  font-weight: 400;
  color: ${({ theme }) => theme.grayColor1};
  position: relative;
  .bonus-descr {
    margin-top: 24px;
  }
  .divider {
    display: none;

    @media (${device.mobile}) {
      display: block;
      margin: 0 auto;
      width: fit-content;
      margin-top: 16px;
    }
  }
  .date {
    margin-bottom: 32px;
    p {
      font-weight: 700;
      font-size: 12px;
      line-height: 18px;
      text-align: center;
      margin: 0;
      color: ${({ theme }) => theme.grayColor1};
    }
  }

  h2 {
    color: ${({ theme }) => theme.whiteColor};
    font-weight: 700;
    letter-spacing: 0.01em;
    text-align: center;
  }

  h2 {
    align-self: center;
    position: relative;
    font-size: 16px;
    line-height: 1.25;
    width: fit-content;
    margin: 32px auto 0;
    max-width: calc(100% - 140px);
    &:first-child {
      margin-top: 0;
    }
  }
  h3,
  h4,
  h5,
  h6 {
    color: ${({ theme }) => theme.secondaryColor};
    font-weight: bold;
    font-size: 16px;
    margin-top: 48px;
    line-height: 1.25;
    letter-spacing: 0.01em;
    &:first-child {
      margin-top: 0;
    }
  }

  p {
    margin: 16px 0 0 0;
    &:first-child {
      margin: 0;
    }
  }
  ul,
  ol {
    margin: 24px 0 0 1.5em;
    line-height: 2;
  }
  a {
    color: ${({ theme }) => theme.greenColor};
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }

  .horizontal-scroll {
    overflow-x: auto;
  }

  table {
    width: 100%;
    border-collapse: collapse;
  }
  th,
  td {
    border: 1px solid ${({ theme }) => theme.secondaryColor};
    padding: 8px;
    text-align: left;
  }
`;

export const ScStaticModalSkeleton = styled.div`
  position: relative;
  max-width: 640px;
  background: ${({ theme }) => theme.secondaryColor3};
  border-radius: 16px;
  margin: 72px auto;
  padding: 32px 24px;
  height: 78vh;
`;

export const ScStaticModalSkeletonMobile = styled.div`
  position: relative;
  bottom: 0;
  width: 100%;
  background: ${({ theme }) => theme.secondaryColor3};
  margin-top: 72px;
  padding: 32px 16px;
  height: calc(100vh - 72px);
  border-radius: 16px 16px 0px 0px;
`;
